<div class="empty-cell" (click)="openEmptyProgrammeModal()">
  &nbsp;
  @if (planningRegionService.hasCommentByDateAndScreenId(data, wednesday, screen().screen_id)) {
    <div class="film-commentaires">
      {{ planningRegionService.getCommentByDateAndScreenId(data, wednesday, screen().screen_id) }}
    </div>
  }
</div>
